import React from "react";
import "../styles/footer.css";

function Footer() {
  return (
    <div className="footer-container">
      <h3>
        Coded from Scratch &copy; Copyright 2025 ncortes04 All Rights Reserved
      </h3>
    </div>
  );
}

export default Footer;
